import React, { useState } from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import M_Footer from './M_Footer';
import { Link } from 'react-router-dom';
import TopTitle from './TopTitle';
import queryString from 'query-string';
import axios from 'axios';
import {instance} from './common';

function checkNum(inputs){
    const session = JSON.parse(window.sessionStorage.result);
    const {u_type} = session;
    
    let obj = {co_number:inputs,u_type:u_type}
    console.log('obj : ',obj)
    const fetchData = async () => {
        instance.post('/contract/insert_car',obj).then(function(res){
            
            if(res.data.msg == 'nodata'){
                alert('계약번호가 존재하지 않습니다.');
            }else if(res.data.msg == 'nocar'){
                alert('해당 계약번호에 연동된 차량정보가 존재하지 않습니다.');
            }else{
                updateNum(inputs);
            }
        });
        
    };

    fetchData();
}


function updateNum(inputs){
    const session = JSON.parse(window.sessionStorage.result);
    const {u_login_id,u_type} = session;
    let obj;
    if(u_type == '일반고객'){
        obj = {co_user_id:u_login_id}
    }else if(u_type == '카마스터'){
        obj = {co_user_id2:u_login_id}
    }
    let valueObj = {
        obj:obj,
        whereField:'co_number',
        whereValue:inputs
    }
    
    const fetchData = async () => {
        instance.post('/contract/update',valueObj).then(function(res){
            alert('정상적으로 차량추가가 되었습니다.\n차량정보에서 확인 해보세요.');
            
        });
        
    };

    fetchData();
    
}


function InsertCar({history, location, match}) {


    const [inputs, setInputs]  = useState('');


    const goBack = () => {
        history.goBack();
    };


    const query = queryString.parse(location.search);
    let date = query.date;
    let s_id = query.s_id;
    let si_id = query.si_id;
    

    const onClick = () => {
        checkNum(inputs);
        
    }

    const onChange = (e) => {

        const {name,value} = e.target;

        if(inputs.length > 12){
            alert('계약번호 규칙에 맞는 번호를 입력해주세요.(영문,숫자 포함 13자리)');
            setInputs('');
            return false;
        }else{
            setInputs(value);
        }
        
    }
        
        



  return (
    
    <>
 
    
    <TopTitle title="차량번호 등록"/>
    <Container>
        <div className="c_pad">
            <h5 className="font-weight-bold mb-3">계약번호를 입력해주세요.</h5>
            <div className="c_flex c_boxshadow">
                <div className="col">
                    <input name="num1" type="text" className="c_border" value={inputs} onChange={onChange} autoComplete="off" />
                </div>
            </div>
            <div className="c_flex">
                <div className="c_certify my-3">계약번호를 - 없이 입력해주세요</div>
            </div>
            <div className="btn btn-primary c_coupon_btn r_btnsize" onClick={onClick}>등록</div>
            <div>
                <span className="btn btn-primary r_btnsize mt-3" onClick={goBack}>뒤로가기</span>
            </div>
        </div>
        
    </Container>
    </>
    
  );
}

export default InsertCar;